import { useMemo } from 'react';
import { useMemorizedCacheTag } from '../../../../hooks/useMemorizedCacheTag';
import { useTimeGridQuery } from '../../../../types/planung-graphql-client-defs';
import { TimeGridEntryType } from '../types';

/**
 * Einträge (Stunden und Pausen) eines Zeitrasters, nach Beginn sortiert.
 * `undefined`, solange die Zeitraster noch laden; leer, wenn es das Zeitraster nicht gibt.
 */
export const useTimeGridEntries = (timeGridUuid: string | null | undefined): TimeGridEntryType[] | undefined => {
  const context = useMemorizedCacheTag('TIME_GRID');
  const [{ data }] = useTimeGridQuery({ context });

  return useMemo(
    () => data && (data.timeGrids.find((timeGrid) => timeGrid.uuid === timeGridUuid)?.entries ?? []),
    [data, timeGridUuid],
  );
};

/** Einträge aller Zeitraster der Organisation, nach Beginn sortiert. `undefined`, solange sie noch laden. */
export const useAllTimeGridEntries = (): TimeGridEntryType[] | undefined => {
  const context = useMemorizedCacheTag('TIME_GRID');
  const [{ data }] = useTimeGridQuery({ context });

  return useMemo(
    () =>
      data?.timeGrids
        .flatMap((timeGrid) => timeGrid.entries)
        .sort((a, b) => a.start.localeCompare(b.start) || a.uuid.localeCompare(b.uuid)),
    [data],
  );
};
